@keyframes menuEnter {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.menu {
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  border-radius: var(--tuna-shape-borderRadius);
  box-shadow: var(--tuna-shadow-4);
  padding: 8px 0;
  min-width: 112px;
  max-height: calc(100% - 96px);
  overflow: auto;
  outline: 0;
  list-style: none;
  margin: 0;
  z-index: var(--tuna-zIndex-modal);
  animation: menuEnter 120ms ease-out;
  transform-origin: top left;
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: var(--tuna-typography-body2-lineHeight);
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  width: 100%;
  text-align: start;
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.item svg {
  width: 20px;
  height: 20px;
}

.item :global(.tuna-list-item-text__primary) {
  font-size: inherit;
  line-height: inherit;
}

.item[data-highlighted],
.item:hover,
.item:focus-visible {
  background-color: var(--tuna-palette-action-hover);
  outline: none;
}

.selected {
  background-color: var(--tuna-palette-action-selected);
}

/* Chevron-right adornment marking a row that opens a submenu. Right-aligned, inherits text color. */
.submenuTrigger::after {
  content: '';
  flex: none;
  margin-inline-start: auto;
  width: 16px;
  height: 16px;
  background-color: currentColor;
  -webkit-mask: var(--chevron-right) center / contain no-repeat;
  mask: var(--chevron-right) center / contain no-repeat;
  --chevron-right: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M9 6l6 6-6 6' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}

.item[data-disabled],
.item:disabled,
.item[aria-disabled='true'] {
  color: var(--tuna-palette-action-disabled);
  opacity: 0.38;
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .menu {
    animation: none !important;
  }
}
